var map = {
	"./Population.svg": 6824,
	"./analysis.svg": 4024,
	"./blast copy.svg": 2508,
	"./blast.svg": 8743,
	"./browse.svg": 6512,
	"./chazhao.svg": 5485,
	"./contact.svg": 1434,
	"./download.svg": 2058,
	"./fst.svg": 6796,
	"./genome.svg": 2441,
	"./genome1.svg": 1146,
	"./go.svg": 8160,
	"./gwas.svg": 5874,
	"./gwas1.svg": 9721,
	"./home.svg": 2891,
	"./jiyinxin.svg": 3753,
	"./kegg.svg": 399,
	"./language.svg": 3921,
	"./lianjie.svg": 2033,
	"./link.svg": 5292,
	"./msa.svg": 4927,
	"./pathway.svg": 1830,
	"./peo.svg": 9034,
	"./pi.svg": 8352,
	"./qtl.svg": 9109,
	"./search.svg": 9486,
	"./search1.svg": 1416,
	"./sequence.svg": 2896,
	"./sequence1.svg": 503,
	"./structure.svg": 7789,
	"./te.svg": 1774,
	"./tools.svg": 2161
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1620;